import {
  Component,
  computed,
  inject,
  Signal,
  ChangeDetectionStrategy
} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {ActivatedRoute} from '@angular/router';
import {LocalStorageService} from '../../../services/infrastructure/page/storage/local-storage/local-storage.service';
import {Constants} from '../../../common/constants/constants';
import {SessionStorageService} from '../../../services/infrastructure/page/storage/session-storage/session-storage.service';
import {BackgroundTaskService} from '../../../services/infrastructure/page/error/background-task/background-task.service';

@Component({
  selector: 'app-clear-session',
  templateUrl: './clear-session.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './clear-session.component.scss',
})
export class ClearSessionComponent {

  private localStorageService: LocalStorageService = inject(LocalStorageService);


  private readonly backgroundTaskService: BackgroundTaskService = inject(BackgroundTaskService);

  private sessionStorageService: SessionStorageService = inject(SessionStorageService);

  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  // `queryParamMap` is backed by a BehaviorSubject, so it emits synchronously on
  // subscribe — `requireSync` is safe and gives a non-nullable signal.
  private queryParamMap = toSignal(this.activatedRoute.queryParamMap, {requireSync: true});

  // The action query param, defaulting to a refresh.
  private actionName: Signal<string> = computed(
    () => this.queryParamMap().get(Constants.SESSION_ACTION) || Constants.SESSION_REFRESH,
  );

  constructor() {
    this.backgroundTaskService.runInBackground(this.initProcessClearSession());
  }

  /**
   * Method: Initialize process clear session
   */
  private async initProcessClearSession(): Promise<void> {
    // Broadcast to OTHER tabs FIRST: writing the flag fires a `storage` event in
    // every other same-origin tab (it never fires in THIS tab). Doing it before
    // handleSessionAction matters for logout, whose signoutRedirect() unloads
    // this tab and would otherwise skip the write.
    this.localStorageService.setClearSessionStorageFlag(this.actionName());
    // Then run the action in THIS tab too. handleSessionAction no longer removes
    // the flag, so the broadcast above survives (no same-tick coalescing).
    await this.sessionStorageService.handleSessionAction(this.actionName());
  }

}
